import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import API from 'api';

import * as Styled from './Download.styles';

type DownloadProps = {
  documentId: string;
  documentName: string;
};

const saveFile = (fileContent: string, name: string) => {
  const url = window.URL.createObjectURL(new Blob([fileContent], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const Download = ({ documentId, documentName }: DownloadProps) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    API.documents
      .getDocumentsIDFile(documentId)
      .then((file) => {
        saveFile(file, documentName);
      })
      .catch(() => {
        message.error(t(`error.fileDownload`));
      });
  };

  return (
    <Styled.DownloadActionLink to="#" onClick={handleDownload}>
      <Styled.IconPaperClip />
      {documentName}
      <Styled.DownloadIcon />
    </Styled.DownloadActionLink>
  );
};

export default Download;
